import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c2cbb65"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "post d-flex flex-column-fluid example-screen",
  id: "kt_post"
}
const _hoisted_2 = {
  id: "kt_content_container",
  class: "container-fluid px-0"
}
const _hoisted_3 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_4 = { class: "flex-column flex-lg-row-auto w-100 w-lg-400px w-xl-450px" }
const _hoisted_5 = { class: "card card-one me-lg-5 mb-5 mb-lg-0" }
const _hoisted_6 = {
  class: "card-header px-5 py-4 position-sticky bg-white top-0 z-index-1",
  id: "kt_chat_contacts_header"
}
const _hoisted_7 = { class: "d-flex flex-stack" }
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = {
  class: "w-100 position-relative",
  autocomplete: "off"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    opacity: "0.5",
    x: "17.0365",
    y: "15.1223",
    width: "8.15546",
    height: "2",
    rx: "1",
    transform: "rotate(45 17.0365 15.1223)",
    fill: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z",
    fill: "black"
  })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  class: "d-none"
}, null, -1))
const _hoisted_14 = { class: "ms-5" }
const _hoisted_15 = { class: "d-flex align-items-center" }
const _hoisted_16 = {
  class: "card-body py-5 px-0",
  id: "kt_chat_contacts_body"
}
const _hoisted_17 = { class: "d-flex flex-stack p-5 pt-0" }
const _hoisted_18 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_19 = {
  key: 0,
  class: "form-check me-2"
}
const _hoisted_20 = ["checked"]
const _hoisted_21 = { class: "ms-1" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(`fas fa-trash-alt btn-outline-danger`)
}, null, -1))
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { style: {"margin-left":"12.5rem"} }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-sync fs-1 text-primary" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-lg-5 d-flex align-items-center" }
const _hoisted_32 = {
  key: 0,
  class: "form-check me-2"
}
const _hoisted_33 = ["value", "onClick"]
const _hoisted_34 = { class: "ms-1" }
const _hoisted_35 = ["title"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "col-lg-6 d-flex flex-column align-items-end ms-2" }
const _hoisted_39 = { class: "text-muted fs-7" }
const _hoisted_40 = {
  key: 0,
  class: "badge badge-danger badge-round-50"
}
const _hoisted_41 = {
  key: 1,
  class: "badge badge-cyan badge-round-50"
}
const _hoisted_42 = {
  key: 2,
  class: "badge badge-success badge-round-50"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed d-none" }, null, -1))
const _hoisted_44 = { class: "d-flex justify-content-between px-5 pt-3 card-footer position-sticky bg-white bottom-0" }
const _hoisted_45 = { class: "w-70px" }
const _hoisted_46 = ["value"]
const _hoisted_47 = {
  key: 0,
  class: "flex-lg-row-fluid"
}
const _hoisted_48 = {
  class: "card-header justify-content-end ribbon ribbon-start",
  style: {"margin-left":"5px"}
}
const _hoisted_49 = {
  key: 0,
  class: "ribbon-label badge-cyan fs-5"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle pe-1 fs-4 text-white" }, null, -1))
const _hoisted_51 = {
  key: 1,
  class: "ribbon-label bg-success fs-5"
}
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check pe-1 fs-4 text-white" }, null, -1))
const _hoisted_53 = {
  key: 2,
  class: "ribbon-label bg-danger fs-5"
}
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pe-1 text-white" }, null, -1))
const _hoisted_55 = { class: "card-title" }
const _hoisted_56 = { class: "d-flex align-items-center" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["title"]
const _hoisted_59 = ["title"]
const _hoisted_60 = ["title"]
const _hoisted_61 = { class: "card-body" }
const _hoisted_62 = { class: "d-flex flex-wrap gap-2 justify-content-between mb-8" }
const _hoisted_63 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_64 = { class: "fw-bold me-3 my-1" }
const _hoisted_65 = { class: "d-flex align-items-center flex-wrap gap-2" }
const _hoisted_66 = { class: "fw-bold text-muted text-end me-3" }
const _hoisted_67 = { "data-kt-inbox-message": "message_wrapper" }
const _hoisted_68 = { class: "d-block" }
const _hoisted_69 = { class: "d-flex align-items-center border-bottom min-h-50px" }
const _hoisted_70 = { class: "text-dark fw-bolder w-75px" }
const _hoisted_71 = ["title", "value"]
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-auto w-75px text-end" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "btn btn-active-light-primary btn-icon btn-circle btn-sm me-2",
    "data-bs-toggle": "modal",
    "data-bs-target": "#email-status"
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ellipsis-h fs-2" })
  ])
], -1))
const _hoisted_73 = /*#__PURE__*/_createStaticVNode("<div class=\"d-flex d-none align-items-center border-bottom min-h-50px\" data-v-7c2cbb65><div class=\"text-dark fw-bolder w-75px\" data-v-7c2cbb65>CC:</div><input type=\"text\" class=\"form-control border-0 text-black-50\" value=\"user1@texst.com;\" data-v-7c2cbb65><div class=\"ms-auto w-75px text-end\" data-v-7c2cbb65><a class=\"btn btn-active-light-primary btn-icon btn-circle btn-sm me-2\" data-bs-toggle=\"modal\" data-bs-target=\"#email-status\" data-v-7c2cbb65><i class=\"fas fa-ellipsis-h fs-2\" data-v-7c2cbb65></i></a></div></div><div class=\"d-flex align-items-center d-none border-bottom min-h-50px\" data-v-7c2cbb65><div class=\"text-dark fw-bolder w-75px\" data-v-7c2cbb65>BCC:</div><input type=\"text\" class=\"form-control border-0 text-black-50\" value=\"user1@texst.com; user3@texst.com\" data-v-7c2cbb65><div class=\"ms-auto w-75px text-end\" data-v-7c2cbb65><a class=\"btn btn-active-light-primary btn-icon btn-circle btn-sm me-2\" data-bs-toggle=\"modal\" data-bs-target=\"#email-status\" data-v-7c2cbb65><i class=\"fas fa-ellipsis-h fs-2\" data-v-7c2cbb65></i></a></div></div>", 2)
const _hoisted_75 = {
  class: "collapse fade show",
  "data-kt-inbox-message": "message"
}
const _hoisted_76 = { class: "py-5" }
const _hoisted_77 = ["srcdoc"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator my-6" }, null, -1))
const _hoisted_79 = {
  key: 0,
  class: "p-3"
}
const _hoisted_80 = { class: "mb-3" }
const _hoisted_81 = { class: "nav-item" }
const _hoisted_82 = {
  href: "javascript:;",
  class: "nav-link text-body"
}
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "las la-file text-dark fs-4" }, null, -1))
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-muted tx-11" }, "(5.10MB)", -1))
const _hoisted_85 = /*#__PURE__*/_createStaticVNode("<li class=\"nav-item\" data-v-7c2cbb65><a href=\"javascript:;\" class=\"nav-link text-body\" data-v-7c2cbb65><span class=\"las la-file text-dark fs-4\" data-v-7c2cbb65></span> Instructions.zip <span class=\"text-muted tx-11\" data-v-7c2cbb65>(3.15 MB)</span></a></li><li class=\"nav-item\" data-v-7c2cbb65><a href=\"javascript:;\" class=\"nav-link text-body\" data-v-7c2cbb65><span class=\"las la-file text-dark fs-4\" data-v-7c2cbb65></span> Team-list.pdf <span class=\"text-muted tx-11\" data-v-7c2cbb65>(4.5 MB)</span></a></li>", 2)
const _hoisted_87 = {
  class: "modal fade",
  id: "email-status",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_88 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_89 = { class: "modal-content" }
const _hoisted_90 = {
  class: "modal-header",
  id: "email-status_header"
}
const _hoisted_91 = { class: "fw-bolder" }
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"btn btn-icon btn-sm btn-active-icon-primary close\" data-bs-dismiss=\"modal\" aria-label=\"Close\" data-v-7c2cbb65><span class=\"svg-icon svg-icon-1\" data-v-7c2cbb65><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" data-v-7c2cbb65><rect opacity=\"0.5\" x=\"6\" y=\"17.3137\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(-45 6 17.3137)\" fill=\"black\" data-v-7c2cbb65></rect><rect x=\"7.41422\" y=\"6\" width=\"16\" height=\"2\" rx=\"1\" transform=\"rotate(45 7.41422 6)\" fill=\"black\" data-v-7c2cbb65></rect></svg></span></div>", 1)
const _hoisted_93 = { class: "modal-body scroll-y bg-opacity-50 bg-light p-5" }
const _hoisted_94 = { class: "table-responsive bg-white border" }
const _hoisted_95 = { class: "table gy-3 gs-5" }
const _hoisted_96 = { class: "fw-bold fs-6 text-gray-800 border-bottom border-gray-200" }
const _hoisted_97 = { class: "text-end" }
const _hoisted_98 = { class: "text-end" }
const _hoisted_99 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_100 = { class: "badge badge-danger badge-round-50" }
const _hoisted_101 = ["onClick"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-redo-alt fs-3" }, null, -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = {
  key: 1,
  class: "badge badge-success badge-round-50"
}
const _hoisted_105 = {
  key: 2,
  class: "badge badge-cyan badge-round-50"
}
const _hoisted_106 = { class: "modal-footer d-flex justify-content-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZFilter = _resolveComponent("VZFilter")!
  const _component_VZModal = _resolveComponent("VZModal")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("form", _hoisted_9, [
                      _createElementVNode("span", {
                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.searchChange && _ctx.searchChange(...args))),
                        class: "svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 ms-3 translate-middle-y"
                      }, _hoisted_11),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control ps-13 mb-2 mb-sm-0",
                        name: "search",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchEmail) = $event)),
                        onKeyup: _cache[2] || (_cache[2] = 
                        () => {
                          if (
                            _ctx.searchEmail.length == 0 ||
                            _ctx.searchEmail.length >= 3
                          )
                            _ctx.searchChange();
                        }
                      ),
                        placeholder: `${_ctx.t('pages.email.searchByEmail')}`
                      }, null, 40, _hoisted_12), [
                        [_vModelText, _ctx.searchEmail]
                      ]),
                      _hoisted_13
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedData, (data) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: data,
                          class: "fw-bolder text-gray-900 text-hover-primary mb-2"
                        }, _toDisplayString(data.fromEmail), 1))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_VZFilter, {
                    options: _ctx.options,
                    defaultFilter: {},
                    viewName: "emailFilter",
                    "menu-placement": "bottom-start",
                    onFilterChange: _ctx.filterChange
                  }, null, 8, ["options", "onFilterChange"])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_17, [
                    (
                      _ctx.hasPermissionWrapper(
                        _ctx.VZ_PERMISSIONS.APPLICATIONS_EMAIL,
                        'DELETE'
                      )
                    )
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          (_ctx.emailsData.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "form-check-input",
                                  id: "inboxCheckAll",
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.allSelected) = $event)),
                                  checked: 
                          _ctx.selectedForDelete.length > 0 &&
                          _ctx.emailsData.length > 0 &&
                          _ctx.selectedForDelete.length === _ctx.emailsData.length
                        ,
                                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.selectAll && _ctx.selectAll(...args)))
                                }, null, 8, _hoisted_20), [
                                  [_vModelCheckbox, _ctx.allSelected]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(`btn btn-outline btn-outline-danger btn-active-light-danger me-5`),
                              disabled: _ctx.disableButton,
                              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDialog = true))
                            }, [
                              _hoisted_23,
                              _createTextVNode(" " + _toDisplayString(_ctx.t("common.delete")), 1)
                            ], 8, _hoisted_22),
                            _createVNode(_component_VZModal, {
                              id: `vz_modal_bulk_delete_email`,
                              title: `${_ctx.t('common.confirmDelete')}`,
                              showDialog: _ctx.showDialog,
                              onModalClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDialog = false)),
                              widthClass: 'width-550'
                            }, {
                              actions: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDialog = false))
                                }, _toDisplayString(_ctx.t("common.close")), 1),
                                (_ctx.disableButton == true)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
                                      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.applyDelete && _ctx.applyDelete(...args)))
                                    }, _toDisplayString(_ctx.t("common.delete")), 1))
                                  : _createCommentVNode("", true),
                                (_ctx.disableButton == false)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      type: "button",
                                      class: "btn btn-outline btn-outline-danger btn-active-light-danger min-w-90px",
                                      onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onBulkDelete && _ctx.onBulkDelete(...args)))
                                    }, _toDisplayString(_ctx.t("common.delete")), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              default: _withCtx(() => [
                                (_ctx.bulkDelete)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.t("validation.sureToDelete")) + " " + _toDisplayString(_ctx.t("pages.email.selectedEmail")), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["title", "showDialog"])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("button", {
                              onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refreshList && _ctx.refreshList(...args)), ["stop"])),
                              type: "button",
                              class: "btn bg-transparent position-relative d-block pe-0"
                            }, _hoisted_27)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_28,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emailsData, (data) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["d-flex flex-stack p-5 hoverClass bg-normal", {
                    'bg-normal': data.webId !== _ctx.selectedData[0]?.webId,
                    'bg-selected': data.webId === _ctx.selectedData[0]?.webId,
                  }]),
                      key: data,
                      onClick: ($event: any) => (_ctx.getEmailDetails(data.webId))
                    }, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          (
                          _ctx.hasPermissionWrapper(
                            _ctx.VZ_PERMISSIONS.APPLICATIONS_EMAIL,
                            'DELETE'
                          )
                        )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  class: "form-check-input",
                                  value: data.webId,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedForDelete) = $event)),
                                  onClick: ($event: any) => (_ctx.checkSingle(data.webId))
                                }, null, 8, _hoisted_33), [
                                  [_vModelCheckbox, _ctx.selectedForDelete]
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("a", {
                              class: _normalizeClass(["fs-6 fw-bold text-gray-900 text-hover-primary mb-2", 
                            _ctx.isUnreadForCurrentUser(data)
                              ? 'text-unread text-dark'
                              : ''
                          ])
                            }, [
                              (data.subject != null)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    "data-bs-toggle": "tooltip",
                                    "data-bs-placement": "top",
                                    title: data.subject
                                  }, _toDisplayString(data.subject && data.subject.length > 20
                                ? data.subject.slice(0, 19) + "..."
                                : data.subject), 9, _hoisted_35))
                                : (_openBlock(), _createElementBlock("div", _hoisted_36, "No Subject for this data..."))
                            ], 2),
                            _createElementVNode("div", {
                              class: _normalizeClass(["fw-bold text-muted", 
                            _ctx.isUnreadForCurrentUser(data)
                              ? 'text-unread text-dark'
                              : ''
                          ])
                            }, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.emailRecipientModel, (subdata) => {
                                return (_openBlock(), _createElementBlock("div", { key: subdata }, [
                                  (subdata.emailAddress != '')
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        "data-bs-toggle": "tooltip",
                                        "data-bs-placement": "top",
                                        title: subdata.emailAddress,
                                        class: "truncate"
                                      }, [
                                        _createElementVNode("span", null, _toDisplayString(subdata.emailAddress) + "; ", 1)
                                      ], 8, _hoisted_37))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ], 2)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.format.DateAndTime(data.startDate)), 1),
                          (data.status == 'FAILED')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(_ctx.t("common.failed")), 1))
                            : _createCommentVNode("", true),
                          (data.status == 'PENDING')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_41, _toDisplayString(_ctx.t("common.pending")), 1))
                            : _createCommentVNode("", true),
                          (data.status == 'SUCCESS')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(_ctx.t("common.delivered")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 10, _hoisted_29))
                  }), 128)),
                  _hoisted_43
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", _hoisted_45, [
                      _withDirectives(_createElementVNode("select", {
                        name: "kt_customers_table_length",
                        class: "form-select form-select-sm",
                        onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args))),
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.rowsPerPage) = $event))
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.PAGE_ITEM, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            value: item
                          }, _toDisplayString(item), 9, _hoisted_46))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.rowsPerPage]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_el_pagination, {
                      "current-page": _ctx.page,
                      "onUpdate:current-page": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.page) = $event)),
                      onCurrentChange: _ctx.currentPageChange,
                      "page-size": +_ctx.rowsPerPage || 0,
                      layout: "prev, pager, next",
                      total: _ctx.total,
                      "hide-on-single-page": false,
                      "pager-count": 5,
                      background: ""
                    }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
                  ])
                ])
              ])
            ])
          ]),
          (_ctx.emailsData.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedData, (data) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card card-one",
                    key: data
                  }, [
                    _createElementVNode("div", _hoisted_48, [
                      (data.status === 'PENDING')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                            _hoisted_50,
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.pending")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (data.status === 'SUCCESS')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                            _hoisted_52,
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.delivered")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (data.status == 'FAILED')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                            _hoisted_54,
                            _createTextVNode(" " + _toDisplayString(_ctx.t("common.failed")), 1)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          (data.status == 'FAILED')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                onClick: ($event: any) => (_ctx.resend(data.webId))
                              }, [
                                _createElementVNode("i", {
                                  class: "las la-retweet text-muted cursor fs-1 fw-bolder",
                                  "data-bs-toggle": "tooltip",
                                  title: `${_ctx.t('common.retry')}`
                                }, null, 8, _hoisted_58)
                              ], 8, _hoisted_57))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", null, [
                            _createElementVNode("i", {
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.printEmail())),
                              class: "las la-print text-muted cursor fs-1 ms-3",
                              "data-bs-toggle": "tooltip",
                              title: `${_ctx.t('common.print')}`
                            }, null, 8, _hoisted_59)
                          ]),
                          (
                      _ctx.hasPermissionWrapper(
                        _ctx.VZ_PERMISSIONS.APPLICATIONS_EMAIL,
                        'DELETE'
                      )
                    )
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showDialog = true))
                              }, [
                                _createElementVNode("i", {
                                  class: "las la-trash text-muted cursor fs-1 ms-3",
                                  "data-bs-toggle": "tooltip",
                                  title: `${_ctx.t('common.delete')}`
                                }, null, 8, _hoisted_60)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("div", _hoisted_63, [
                          _createElementVNode("h2", _hoisted_64, [
                            _createTextVNode(_toDisplayString(_ctx.t("pages.email.subject")) + " ", 1),
                            _createElementVNode("small", null, _toDisplayString(data.subject), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.format.DateAndTime(data.createdDate)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_67, [
                        _createElementVNode("div", _hoisted_68, [
                          _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.t("pages.email.to")), 1),
                            _createElementVNode("input", {
                              type: "text",
                              title: _ctx.getEmailAddresses(data.emailRecipientModel),
                              class: "form-control border-0 text-black-50 text-truncate",
                              value: _ctx.getEmailAddresses(data.emailRecipientModel),
                              readonly: ""
                            }, null, 8, _hoisted_71),
                            _hoisted_72
                          ]),
                          _hoisted_73
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("iframe", {
                              srcdoc: data.body,
                              class: "iframe w-100 h-450px",
                              sandbox: ""
                            }, null, 8, _hoisted_77)
                          ])
                        ])
                      ]),
                      _hoisted_78,
                      (data?.emailAttachmentModel?.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _createTextVNode(_toDisplayString(_ctx.t("pages.email.attachments")) + " ", 1),
                              _createElementVNode("span", null, "(3 " + _toDisplayString(_ctx.t("pages.email.files")) + ", 12,44 KB)", 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.emailAttachmentModel, (subdata) => {
                              return (_openBlock(), _createElementBlock("ul", {
                                class: "nav flex-column",
                                key: subdata
                              }, [
                                _createElementVNode("li", _hoisted_81, [
                                  _createElementVNode("a", _hoisted_82, [
                                    _hoisted_83,
                                    _createTextVNode(" " + _toDisplayString(subdata.name + ".zip") + " ", 1),
                                    _hoisted_84
                                  ])
                                ]),
                                _hoisted_85
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_87, [
      _createElementVNode("div", _hoisted_88, [
        _createElementVNode("div", _hoisted_89, [
          _createElementVNode("div", _hoisted_90, [
            _createElementVNode("h2", _hoisted_91, _toDisplayString(_ctx.t("pages.email.recipientStatus")), 1),
            _hoisted_92
          ]),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("table", _hoisted_95, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", _hoisted_96, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.t("pages.email.emailAddress")), 1),
                    _createElementVNode("th", _hoisted_97, _toDisplayString(_ctx.t("common.status")), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedData, (data) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.emailRecipientModel, (subdata) => {
                        return (_openBlock(), _createElementBlock("tr", { key: subdata }, [
                          _createElementVNode("td", null, _toDisplayString(subdata.emailAddress), 1),
                          _createElementVNode("td", _hoisted_98, [
                            (subdata.status == 'FAILED')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_99, [
                                  _createElementVNode("span", _hoisted_100, _toDisplayString(_ctx.t("common.failed")), 1),
                                  _createElementVNode("a", {
                                    onClick: ($event: any) => (_ctx.resend(subdata.webId)),
                                    class: "btn btn-active-light-primary btn-icon btn-circle btn-sm h-15px w-15px ms-2"
                                  }, _hoisted_103, 8, _hoisted_101)
                                ]))
                              : _createCommentVNode("", true),
                            (data.status == 'SUCCESS')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_104, _toDisplayString(_ctx.t("common.delivered")), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_105, _toDisplayString(_ctx.t("common.pending")), 1))
                          ])
                        ]))
                      }), 128))
                    ], 64))
                  }), 256))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_106, [
            _createElementVNode("button", {
              type: "reset",
              class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.showDialog = false)),
              "aria-label": "Close",
              "data-bs-dismiss": "modal"
            }, _toDisplayString(_ctx.t("common.close")), 1)
          ])
        ])
      ])
    ])
  ], 64))
}